export { default } from "./OglCopyrightNotice";
